import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const fetchCountryBoundsRequest = createAction("".concat(stateName, "/fetchCountryBoundsRequest"));
export const fetchNearbyDropOffOptionsRequest = createAction("".concat(stateName, "/fetchNearbyDropOffOptionsRequest"));